import * as categoriesSelector from "./selectors"

import categoriesActions from "./actions"
import reducer from "./redcuer"

const categoriesReducer = reducer

export { categoriesActions, categoriesReducer, categoriesSelector }
